import React from 'react';
import { BackLayout } from '../../../components/layouts/back/BackLayout';
import { Spinner } from '../../../components/shared/Spinner';
import { useParams } from 'react-router-dom';
import { Language } from '../../../core/models/Language';
import { useGetOne } from '../../../core/hooks/firebase/useGetOne';
import { LanguageDetailForm } from '../../../components/back/form/LanguageDetailForm';
import { RESOURCES } from 'core/constants/resources';

export const LanguageDetail = () => {
    const { id: languageId } = useParams();

    const { data: language, loading } = useGetOne<Language, Language>({
        resource: RESOURCES.LANGUAGES,
        id: languageId,
    });

    if (loading || !language) {
        return (
            <div className="vh-100">
                <Spinner />
            </div>
        );
    }

    return (
        <BackLayout>
            <LanguageDetailForm language={language} />
        </BackLayout>
    );
};
